var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"g-footer"},[_c('div',{staticClass:"g-box"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":this.$i18n.locale == 'en' ? '/en/sitemap' : '/sitemap'}},[_vm._v(_vm._s(_vm.$t("Site.sitemap")))])],1)]),_c('p',[_vm._v("Copyright © National Museum of Ethnology, Japan, All rights reserved")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }